<msf-summary-wrapper
  title="{{ 'Fields Identification' | translate }}"
  [items]="MENU_ITEMS | menuChildren:MenuItemType.FieldIdentification"  leftSize="4"
  rightSize="8">
  <div
    right
    #right>
    <div
      class="summary-card mt-4 p-4 bg-white border-round"
      style="background: #fff; padding: 24px; border-radius: 16px; border: 1px solid #e0e0e0">
      <h2
        class="mb-2"
        style="font-size: 20px; font-weight: 600; color: var(--color-main-font)">
        {{ "Module Description" | translate }}
      </h2>
      <p style="color: #6c757d">
        {{ "Select a tool from the left to proceed with field identification tasks." | translate }}
      </p>
    </div>
  </div>
</msf-summary-wrapper>
